export default __webpack_public_path__ + "static/media/demo-threejs-kubussen.038aecf0.png";